import React from 'react';

import { Typography } from '../../../components/Wrappers/Wrappers.jsx';
import { useStyles } from './goodToKnowSection.styles';

const FAQ_ITEMS = [
    {
        id: 'what-gets-listed',
        q: 'What gets listed?',
        a: 'Your tile is listed on ecalworld.com for easy discovery and recommendation.',
    },
    {
        id: 'how-long-until-appears',
        q: 'How long until it appears?',
        a: "Listings publish to ECAL World within a few minutes of saving. Turning discovery off removes the tile just as quickly.",
    },
    {
        id: 'choose-which-display',
        q: 'How do I choose which display?',
        a: "Select which display appears when users 'Sync to Calendar' from the Manage Displays section of your admin.",
    },
    {
        id: 'does-it-cost-anything',
        q: 'Does it cost anything?',
        a: 'Listing on ECAL World is included with your plan. Featured placement is allocated by the ECAL team based on campaign fit and timing.',
    },
];

function GoodToKnowSection () {
    const classes = useStyles();

    return (
        <div className={classes.card}>
            <Typography variant={'h5'} weight={'bold'} className={classes.heading}>
                Good to know
            </Typography>

            <div className={classes.grid}>
                {FAQ_ITEMS.map((item) => (
                    <div key={item.id}>
                        <Typography variant={'body1'} className={classes.itemQuestion}>
                            {item.q}
                        </Typography>
                        <Typography variant={'body2'} className={classes.itemAnswer}>
                            {item.a}
                        </Typography>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default GoodToKnowSection;
